// Liten badge som viser voucher_type på bilag-rader. Hjelper PL å forstå
// hvorfor f.eks. leverandør kan være tom for TravelExpense (kvitteringer)
// eller PayrollJournal (lønnsbilag). VIB-588.

const TYPE_LABELS: Record<string, { label: string; color: string }> = {
  IncomingInvoice: { label: "Faktura", color: "bg-slate-100 text-slate-700" },
  TravelExpense: { label: "Reise", color: "bg-amber-100 text-amber-700" },
  PayrollJournal: { label: "Lønn", color: "bg-purple-100 text-purple-700" },
  OutgoingCreditNote: { label: "Kreditnota", color: "bg-rose-100 text-rose-700" },
  OutgoingInvoice: { label: "Utgående", color: "bg-emerald-100 text-emerald-700" },
  GeneralJournal: { label: "Diverse", color: "bg-slate-100 text-slate-700" },
};

export function VoucherTypeBadge({ type }: { type: string | null | undefined }) {
  if (!type) return null;
  const meta = TYPE_LABELS[type] ?? {
    label: type,
    color: "bg-slate-100 text-slate-700",
  };
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-medium uppercase tracking-wide ${meta.color}`}
      title={type}
    >
      {meta.label}
    </span>
  );
}
